import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive'; // Import the useMediaQuery hook
import { handleLoginRedirect } from '../../utils/locationUtils';
import './Footer.css';
import logo from '../../assets/svg/edc-logo-white.svg';
import linkin from '../../assets/svg/edc-linkin.svg';
import tiktok from '../../assets/svg/edc-ticktok.svg';
import instagram from '../../assets/svg/edc-insta.svg';
import whatsapp from '../../assets/svg/edc-whatsapp.svg';
import footerImage from '../../assets/svg/edc-footer-tiktok-creative.svg';
import {
  WHATSAPP_DM_URL,
  WHATSAPP_COMMUNITY_URL,
} from '../../constants/constants';

const Footer = () => {
  const [showPopup, setShowPopup] = useState(false);
  const popupRef = useRef(null);
  const currentYear = new Date().getFullYear();

  // Media query to detect if the screen size is mobile
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  const handleLoginClick = () => {
    handleLoginRedirect();
  };

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const handleClickOutside = event => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setShowPopup(false);
    }
  };

  useEffect(() => {
    if (showPopup) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showPopup]);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          {/* Left Side */}
          <div className="footer-left">
            <h2 className="footer-email">hello@edcsquared.io</h2>
            <div className="footer-social">
              <a
                href="https://www.instagram.com/edcsq/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={instagram} alt="Instagram" className="social-icon" />
              </a>
              <a
                href="https://www.linkedin.com/company/edcsquared/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={linkin} alt="LinkedIn" className="social-icon" />
              </a>
              <div className="popup-container" ref={popupRef}>
                <button onClick={togglePopup} className="social-icon-button">
                  <img
                    src={whatsapp}
                    alt="WhatsApp"
                    className="social-icon-whatsapp"
                  />
                </button>
                {showPopup && (
                  <div className="popup">
                    <a
                      href={WHATSAPP_DM_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Chat Directly
                    </a>
                    <a
                      href={WHATSAPP_COMMUNITY_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Join our Community
                    </a>
                  </div>
                )}
              </div>
              <a
                href="https://www.tiktok.com/@edcsquared"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={tiktok} alt="TikTok" className="social-icon" />
              </a>
            </div>
          </div>

          {/* Right Side: Image */}
          <div className="footer-right">
            <img
              src={footerImage}
              alt="Footer Visual"
              className="footer-image"
            />
          </div>
        </div>

        <div className="footer-bottom">
          {!isMobile && (
            <div className="footer-logo">
              <img src={logo} alt="EDC Squared Logo" />
            </div>
          )}
          <div className="footer-links">
            <div className="footer-column">
              <div className="footer-idividual-column">
                <h4>EDC squared</h4>
                <ul>
                  <li>
                    <Link to="/edc-hive" className="footer-link">
                      The EDC Hive
                    </Link>
                  </li>
                  <li>
                    <Link to="/for-creators" className="footer-link">
                      For Creators
                    </Link>
                  </li>
                  <li>
                    <Link to="/for-brands" className="footer-link">
                      For Brands
                    </Link>
                  </li>
                  <li>
                    <Link to="/our-purpose" className="footer-link">
                      Our Purpose
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="footer-idividual-column">
                <h4>Support</h4>
                <ul>
                  <li>
                    <Link to="/lets-talk" className="footer-link">
                      Let's Connect
                    </Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy" className="footer-link">
                      Privacy Policy
                    </Link>
                  </li>
                  <li>
                    <a
                      href="/EDC-Squared-PAIA-Manual-2026.pdf"
                      className="footer-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      PAIA Manual
                    </a>
                  </li>
                  <li>
                    <Link to="/terms-and-conditions" className="footer-link">
                      Terms and Conditions
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="footer-idividual-column">
                <h4>Join Us</h4>
                <ul>
                  <li>
                    <a
                      href="#login"
                      className="footer-link"
                      onClick={handleLoginClick}
                    >
                      Login or Sign up
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {isMobile && (
          <div className="footer-logo-mobile">
            <img src={logo} alt="EDC Squared Logo" />
          </div>
        )}

        <div className="footer-copyright">
          <p>© {currentYear} Copyright EDC Squared. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
